import { useNavigate } from "react-router-dom";
import { MapPin, Star } from "lucide-react";
import { formatPrice, timeAgo, resolveImageUrl } from "@/lib/api";

export function ListingCard({ listing }) {
  const navigate = useNavigate();
  const img = resolveImageUrl((listing.images && listing.images[0]) || "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&q=80");

  return (
    <div data-testid={`listing-card-${listing.id}`} onClick={() => navigate(`/listing/${listing.id}`)}
      className="bg-white border border-slate-200 rounded-lg overflow-hidden hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 cursor-pointer group">
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
        <img src={img} alt={listing.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
        {listing.premium && (
          <span className="absolute top-2 left-2 inline-flex items-center gap-1 bg-amber-500 text-white text-xs font-semibold px-2 py-1 rounded-md shadow">
            <Star size={12} fill="white" /> Spotlight
          </span>
        )}
        <span className="absolute bottom-2 right-2 bg-slate-900/80 text-white text-xs px-2 py-0.5 rounded">{listing.condition}</span>
      </div>
      <div className="p-3">
        <p className="font-heading font-bold text-lg text-emerald-700">{formatPrice(listing.price, listing.category)}</p>
        <h3 className="text-sm font-medium text-slate-900 line-clamp-2 mt-0.5 min-h-[2.5rem]">{listing.title}</h3>
        <div className="flex items-center justify-between mt-2 text-xs text-slate-500">
          <span className="inline-flex items-center gap-1"><MapPin size={12} /> {listing.county}</span>
          <span>{timeAgo(listing.created_at)}</span>
        </div>
      </div>
    </div>
  );
}
